<script setup>
    import Multiselect from '@vueform/multiselect';
    import Floating from './Floating.vue';
    import { ref } from 'vue';
    const {error = null, canClear = false, disabled = false, objectProp = false} = defineProps({
        label: String,
        options: Array,
        error: Array,
        disabled: Boolean,
        searchable: Boolean,
        canClear: Boolean,
        oneLineSmall: Boolean,
        oneLineMedium: Boolean,
        placeholder: String,
        objectProp: Boolean,
        multiple: Boolean
    })

    const multiselectRef = ref(null);

    const emits = defineEmits(['blur', 'deselect']);
    function close(){
        multiselectRef.value.deactivate();
    }
    const modelValue = defineModel()
</script>


<template>
    <component :is="label ? Floating : 'div'" :error="label ? error : ''" :label="label" :one-line-small="oneLineSmall" :one-line-medium="oneLineMedium">
        <multiselect
            ref="multiselectRef"
            v-model="modelValue"
            :options="options"
            class="form-select"
            style="min-height: none !important;"
            :closeOnSelect="true"
            :class="error?.length > 0 ? ' is-invalid' : ''"
            :allow-empty="true"
            :searchable="searchable"
            :canDeselect="false"
            :canClear="canClear"
            :disabled="disabled"
            :placeholder="placeholder"
            :object="objectProp"
            :mode="multiple ? 'tags' : 'single'"
            trackBy="name"
            @select="(event) => emits('blur',event)"
            @deselect="(event) => emits('deselect', event)"
            @clear="(event) => emits('blur',null)"
            >
            <template v-slot:singlelabel="{ value }">
							<slot name="singlelabel" :value="value">
								<div class="singlelabel" style="width: 100%; line-height: 1;  position: relative;">
									{{ value ? value.name : 'нет значения' }}   
								</div>
							</slot>
            </template>
            <template v-slot:option="{ option }">
                <div style="width: 100%; height:100%; padding: 8px 12px;" @click="close()">
                {{ option.name }}
                </div>
            </template>
        </multiselect>
    </component>
</template>

<style scoped>
    :deep(.multiselect-wrapper){
        min-height: 36px !important;
    }
		:deep(.form-select .multiselect-search) {
			cursor: pointer;
		}
    :deep(.multiselect-clear), :deep(.multiselect-caret){
        z-index: 1;
				cursor: pointer;
    }
		:deep(.multiselect-wrapper:hover .multiselect-caret) {
			background-color: var(--ms-clear-color-hover, #000000); /* Цвет при наведении на wrapper */
		}
		
		:deep(.multiselect-clear:hover ~ .multiselect-caret) {
			background-color: var(--ms-clear-color, #999999); /* Цвет при наведении на clear */
		}
    :deep(.multiselect-tag){
        background: #183548;
    }
		:deep(.slot-container) {
			max-width: 80%;
		}

    :deep(.form-select){
        padding-left: 12px !important
    }
</style>